import TemplateNames from './TemplateNames';

export default {
  title: 'Geautomatiseerde e-mails',
  labels: {
    empty_list: 'Geen sjablonen gevonden',
    load_failed:
      'Je geautomatiseerde e-mails konden niet worden geladen. Herlaad de pagina of neem contact op met de support.',
    on: 'Aan',
    off: 'Uit',
  },
  fields: {
    name: 'Naam',
    messages_delivered: 'Berichten afgeleverd',
    open_rate: 'Openingspercentage',
    click_rate: 'Klikpercentage',
    status: 'Status',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Status bijwerken mislukt',
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
